// ─────────────────────────────────────────────────────────────────────────────
// Deep Link — Public API
// Importar sempre via: import { DeepLinkService } from '@app/core/deeplink';
// ─────────────────────────────────────────────────────────────────────────────

export { DeepLinkService } from "./deeplink.service";
export { dlLog } from "./deeplink-debug.logger";
export {
  isRecoveryPasswordDeepLink,
  matchRecoveryPasswordDeepLink,
  RECOVERY_PASSWORD_ROUTE,
} from "./deeplink.recovery-password";
export type { RecoveryPasswordDeepLink } from "./deeplink.recovery-password";
export type { DeepLinkPayload, DeepLinkOrigin } from "./deeplink.types";
